import React from 'react'
import PropTypes from 'prop-types'
import { Button, Icon } from 'components'
import { ICONS_TYPES } from 'components/Icon/Icon'

const IconButton = ({ buttonProps, iconProps, children }) => {
  return (
    <Button {...buttonProps}>
      <Icon {...iconProps} />
      {children}
    </Button>
  )
}

IconButton.propTypes = {
  children: PropTypes.string,
  buttonProps: PropTypes.shape({
    disabled: PropTypes.bool,
    type: PropTypes.oneOf(['outline', 'filled', 'text']),
    darkColor: PropTypes.bool,
    style: PropTypes.objectOf(PropTypes.any),
    onClick: PropTypes.func.isRequired,
    iconPosition: PropTypes.oneOf(['right', 'left', '']),
    classIcon: PropTypes.oneOf(['primaryColor', 'darkColor', 'whiteColor']),
    fontSize: PropTypes.oneOf(['xsmall', 'small', 'medium']),
    className: PropTypes.string,
  }).isRequired,
  iconProps: PropTypes.shape({
    size: PropTypes.number,
    style: PropTypes.objectOf(PropTypes.object),
    color: PropTypes.oneOf([
      'primaryColor',
      'darkColor',
      'whiteColor',
      'greenColor',
    ]),
    type: PropTypes.oneOf(ICONS_TYPES).isRequired,
  }).isRequired,
}

IconButton.defaultProps = {
  children: '',
}

export default React.memo(IconButton)
